module.exports = __webpack_public_path__ + "static/media/green_star.eaaa8947.svg";